import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaStar, FaStarHalfAlt, FaRegStar, FaChevronDown, FaChevronUp, FaBook, FaSearch, FaUser, FaHome, FaBars, FaTimes, FaFilter } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Footer from "../../components/Footer";
import books from "../../data/HobbiesData/BooksData/BookData"

const BookReviewPage = () => {
  const navigate = useNavigate();
  const [showFullDescription, setShowFullDescription] = useState({});
  const [showFullReview, setShowFullReview] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeFilter, setActiveFilter] = useState("all");
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const formatDescription = (text) => {
    if (!text) return "";
    return text.split("\n").map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index < text.split("\n").length - 1 && <br />}
      </React.Fragment>
    ));
  };


  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleNavigation = (path) => {
    navigate(path);
    setIsMobileMenuOpen(false);
  };

  const toggleDescription = (bookId) => {
    setShowFullDescription((prev) => ({
      ...prev,
      [bookId]: !prev[bookId],
    }));
  };

  const toggleReview = (bookId) => {
    setShowFullReview((prev) => ({
      ...prev,
      [bookId]: !prev[bookId],
    }));
  };

  const toggleFilter = () => {
    setIsFilterOpen(!isFilterOpen);
  };

  const handleFilter = (category) => {
    setActiveFilter(category);
    setIsFilterOpen(false);
  };

  const filteredBooks = books.filter((book) => {
    const matchesSearch = book.title.toLowerCase().includes(searchQuery.toLowerCase()) || book.author.toLowerCase().includes(searchQuery.toLowerCase()) || book.genre.toLowerCase().includes(searchQuery.toLowerCase());

    const matchesFilter = activeFilter === "all" || book.category === activeFilter;

    return matchesSearch && matchesFilter;
  });

  const getFilterCount = (category) => {
    if (category === "all") return books.length;
    return books.filter((book) => book.category === category).length;
  };

  const filterOptions = [
    { value: "all", label: "All Books", count: getFilterCount("all") },
    { value: "self-improvement", label: "Self Improvement", count: getFilterCount("self-improvement") },
    { value: "novel", label: "Novel", count: getFilterCount("novel") },
    { value: "komik", label: "Komik", count: getFilterCount("komik") },
  ];

  // Fungsi untuk mendapatkan deskripsi yang dipotong dengan format yang benar
  const getTruncatedText = (text, maxLength = 150) => {
    if (!text) return "";
    if (text.length <= maxLength) return text;

    // Potong teks pada spasi terdekat setelah maxLength
    const truncated = text.substring(0, maxLength);
    const lastSpaceIndex = truncated.lastIndexOf(" ");

    return lastSpaceIndex > 0 ? truncated.substring(0, lastSpaceIndex) + "..." : truncated + "...";
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-gradient-to-r from-green-500 to-green-800 text-white pixel-border-bottom relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div
            className="absolute top-0 left-0 w-full h-full bg-repeat"
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff' fill-opacity='1' fill-rule='evenodd'%3E%3Ccircle cx='3' cy='3' r='3'/%3E%3Ccircle cx='13' cy='13' r='3'/%3E%3C/g%3E%3C/svg%3E")`,
              backgroundSize: "30px",
            }}
          ></div>
        </div>

        <div className="container mx-auto px-4 py-4 relative z-10">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center">
              <motion.div className="mr-3" whileHover={{ rotate: 360 }} transition={{ type: "spring", stiffness: 300 }}>
                <FaBook className="text-2xl" />
              </motion.div>
              <h1 className="text-xl md:text-3xl font-bold pixel-font">REVIEW BUKU FAVORIT</h1>
            </div>

            <div className="hidden md:flex space-x-3">
              <motion.button whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }} onClick={() => navigate("/")} className="flex items-center pixel-button bg-green-700 hover:bg-green-800 px-3 py-2 text-sm" title="Kembali ke Profil">
                <FaHome className="mr-1" />
                <span>Beranda</span>
              </motion.button>
            </div>

            <div className="md:hidden">
              <motion.button whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }} onClick={toggleMobileMenu} className="pixel-button bg-green-700 hover:bg-green-800 p-2" aria-label="Toggle Menu">
                {isMobileMenuOpen ? <FaTimes className="text-lg" /> : <FaBars className="text-lg" />}
              </motion.button>
            </div>
          </div>

          <div className="flex mb-2">
            <div className={`flex items-center pixel-border bg-white px-3 py-2 transition-all duration-300 ${isSearchFocused ? "ring-2 ring-green-400" : ""} w-full md:w-96`}>
              <FaSearch className="text-gray-400 mr-2" />
              <input
                type="text"
                placeholder="Cari judul, penulis, atau genre..."
                className="bg-transparent outline-none text-gray-800 placeholder-gray-400 w-full"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onFocus={() => setIsSearchFocused(true)}
                onBlur={() => setIsSearchFocused(false)}
              />
            </div>
          </div>

          <AnimatePresence>
            {isMobileMenuOpen && (
              <motion.div className="md:hidden bg-green-700 pixel-border mt-4" initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }} exit={{ opacity: 0, height: 0 }} transition={{ duration: 0.3 }}>
                <div className="p-3 space-y-2">
                  <motion.button
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    onClick={() => handleNavigation("/")}
                    className="w-full flex items-center justify-center pixel-button bg-green-600 hover:bg-green-800 px-3 py-2 text-sm"
                  >
                    <FaHome className="mr-2" />
                    <span>Kembali ke Beranda</span>
                  </motion.button>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </header>

      <main className="container mx-auto px-4 py-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 mb-8">
          <div className="md:hidden relative w-full">
            <motion.button whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }} onClick={toggleFilter} className="flex items-center justify-center pixel-button bg-green-600 hover:bg-green-700 px-4 py-2 w-full">
              <FaFilter className="mr-2" />
              <span>{filterOptions.find((opt) => opt.value === activeFilter)?.label}</span>
              {isFilterOpen ? <FaChevronUp className="ml-2" /> : <FaChevronDown className="ml-2" />}
            </motion.button>

            <AnimatePresence>
              {isFilterOpen && (
                <motion.div className="absolute top-full left-0 right-0 mt-2 bg-white pixel-border z-50" initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }} transition={{ duration: 0.2 }}>
                  {filterOptions.map((option) => (
                    <button
                      key={option.value}
                      onClick={() => handleFilter(option.value)}
                      className={`flex items-center justify-between w-full px-4 py-3 text-left hover:bg-gray-100 transition-colors ${activeFilter === option.value ? "bg-green-50 text-green-700 font-semibold" : "text-gray-800"}`}
                    >
                      <span>{option.label}</span>
                      <span className="bg-gray-200 text-gray-700 text-xs px-2 py-1 rounded-full">{option.count}</span>
                    </button>
                  ))}
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </div>

        <div className="hidden md:flex flex-wrap gap-2 mb-6 justify-center">
          {filterOptions.map((option) => (
            <motion.button
              key={option.value}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => setActiveFilter(option.value)}
              className={`flex items-center pixel-button px-4 py-2 transition-all ${activeFilter === option.value ? "bg-green-600 text-white" : "bg-gray-200 text-gray-700 hover:bg-gray-300"}`}
            >
              {option.label}
              <span className={`ml-2 text-xs px-2 py-1 rounded-full ${activeFilter === option.value ? "bg-green-500 text-white" : "bg-gray-300 text-gray-700"}`}>{option.count}</span>
            </motion.button>
          ))}
        </div>

        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }} className="text-center mb-8">
          <p className="text-gray-600 max-w-2xl mx-auto">Berikut adalah koleksi buku-buku yang telah saya baca dan reviewnya.</p>
        </motion.div>

        {(searchQuery || activeFilter !== "all") && (
          <motion.div className="mb-6 p-3 bg-green-50 pixel-border text-green-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3" initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }}>
            <div className="flex flex-wrap items-center gap-2">
              <span>
                Menampilkan <span className="font-bold">{filteredBooks.length}</span> hasil
              </span>
              {searchQuery && <span className="bg-green-100 text-green-800 px-2 py-1 rounded text-sm">Pencarian: "{searchQuery}"</span>}
              {activeFilter !== "all" && <span className="bg-green-200 text-green-800 px-2 py-1 rounded text-sm">Kategori: {filterOptions.find((opt) => opt.value === activeFilter)?.label}</span>}
            </div>
            <div className="flex gap-2">
              {searchQuery && (
                <button onClick={() => setSearchQuery("")} className="text-green-600 hover:text-green-800 font-medium pixel-button bg-green-100 px-3 py-1 text-sm">
                  Hapus Pencarian
                </button>
              )}
              {(activeFilter !== "all" || searchQuery) && (
                <button
                  onClick={() => {
                    setActiveFilter("all");
                    setSearchQuery("");
                  }}
                  className="text-green-600 hover:text-green-800 font-medium pixel-button bg-green-100 px-3 py-1 text-sm"
                >
                  Reset Semua
                </button>
              )}
            </div>
          </motion.div>
        )}

        <div className="space-y-8">
          <AnimatePresence>
            {filteredBooks.map((book, index) => {
              const truncatedDescription = getTruncatedText(book.description, 150);
              const truncatedReview = getTruncatedText(book.review, 200);
              const isDescriptionTruncated = book.description.length > 150;
              const isReviewTruncated = book.review.length > 200;

              return (
                <motion.div key={book.id} className="bg-white pixel-border p-4 md:p-6" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: index * 0.1 }} exit={{ opacity: 0, y: -20 }}>
                  <div className="flex flex-col lg:flex-row gap-4 md:gap-6">
                    <div className="flex-shrink-0 flex flex-col items-center">
                      <div className="w-32 h-48 md:w-40 md:h-60 pixel-border overflow-hidden mx-auto">
                        <img src={book.image} alt={book.title} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" />
                      </div>
                      <span
                        className={`mt-2 px-3 py-1 text-xs font-semibold rounded-full ${
                          book.category === "self-improvement" ? "bg-blue-100 text-blue-800" : book.category === "novel" ? "bg-purple-100 text-purple-800" : "bg-orange-100 text-orange-800"
                        }`}
                      >
                        {book.category === "self-improvement" ? "Self Improvement" : book.category === "novel" ? "Novel" : "Komik"}
                      </span>
                    </div>

                    <div className="flex-1">
                      <h3 className="text-xl md:text-2xl font-bold text-gray-800 mb-2 pixel-font">{book.title}</h3>
                      <p className="text-gray-600 mb-3 text-sm md:text-base">
                        oleh <span className="font-semibold">{book.author}</span>
                      </p>

                      <div className="mb-4">
                        <h4 className="text-lg font-semibold text-gray-800 mb-2 flex items-center">
                          <div className="w-3 h-3 bg-blue-600 mr-2"></div>
                          Deskripsi Buku
                        </h4>
                        <div className="text-gray-700 leading-relaxed text-sm md:text-base whitespace-pre-line">
                          {showFullDescription[book.id] ? formatDescription(book.description) : formatDescription(truncatedDescription)}
                          {isDescriptionTruncated && (
                            <button onClick={() => toggleDescription(book.id)} className="text-green-600 hover:text-green-800 font-medium ml-2 flex items-center mt-1">
                              {showFullDescription[book.id] ? (
                                <>
                                  <span>Sembunyikan</span>
                                  <FaChevronUp className="ml-1" />
                                </>
                              ) : (
                                <>
                                  <span>Selengkapnya</span>
                                  <FaChevronDown className="ml-1" />
                                </>
                              )}
                            </button>
                          )}
                        </div>
                      </div>

                      <div className="mb-4">
                        <h4 className="text-lg font-semibold text-gray-800 mb-2 flex items-center">
                          <div className="w-3 h-3 bg-green-600 mr-2"></div>
                          Pendapat Saya
                        </h4>
                        <div className="text-gray-700 leading-relaxed text-sm md:text-base whitespace-pre-line">
                          {showFullReview[book.id] ? formatDescription(book.review) : formatDescription(truncatedReview)}
                          {isReviewTruncated && (
                            <button onClick={() => toggleReview(book.id)} className="text-green-600 hover:text-green-800 font-medium ml-2 flex items-center mt-1">
                              {showFullReview[book.id] ? (
                                <>
                                  <span>Sembunyikan</span>
                                  <FaChevronUp className="ml-1" />
                                </>
                              ) : (
                                <>
                                  <span>Selengkapnya</span>
                                  <FaChevronDown className="ml-1" />
                                </>
                              )}
                            </button>
                          )}
                        </div>
                      </div>

                      <div>
                        <h4 className="text-lg font-semibold text-gray-800 mb-2 flex items-center">
                          <div className="w-3 h-3 bg-purple-600 mr-2"></div>
                          Detail Buku
                        </h4>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
                          <div className="flex items-center">
                            <span className="font-medium text-gray-600 mr-2">Genre:</span>
                            <span className="text-gray-800">{book.genre}</span>
                          </div>
                          <div className="flex items-center">
                            <span className="font-medium text-gray-600 mr-2">Tebal:</span>
                            <span className="text-gray-800">{book.pages} halaman</span>
                          </div>
                          <div className="flex items-center">
                            <span className="font-medium text-gray-600 mr-2">Terbit:</span>
                            <span className="text-gray-800">{book.publishedYear}</span>
                          </div>
                          <div className="flex items-center">
                            <span className="font-medium text-gray-600 mr-2">Publisher:</span>
                            <span className="text-gray-800">{book.publisher}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </motion.div>
              );
            })}
          </AnimatePresence>
        </div>

        {filteredBooks.length === 0 && (
          <motion.div className="text-center py-12" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.3 }}>
            <p className="text-gray-600 mb-4">Tidak ditemukan buku yang sesuai dengan kriteria yang dipilih.</p>
            <button
              onClick={() => {
                setActiveFilter("all");
                setSearchQuery("");
              }}
              className="pixel-button bg-green-600 text-white px-6 py-2 hover:bg-green-700"
            >
              Tampilkan Semua Buku
            </button>
          </motion.div>
        )}
      </main>

      <Footer />
    </div>
  );
};

export default BookReviewPage;
